import { render, staticRenderFns } from "./SummaryReport.vue?vue&type=template&id=5d27f270&scoped=true&"
import script from "./SummaryReport.vue?vue&type=script&lang=js&"
export * from "./SummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./SummaryReport.vue?vue&type=style&index=0&id=5d27f270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d27f270",
  null
  
)

export default component.exports